<template>
	<div elevation="0">
		<v-card-title>
			图表
			<template v-if="form.id">编辑</template>
			<template v-else>创建</template>
		</v-card-title>
		<v-card-subtitle v-if="report">{{ report.name }}</v-card-subtitle>
		<v-card-text v-if="form">
			<v-row>
				<v-col cols="6" sm="6">
					<v-text-field
						label="名称*"
						name="name"
						placeholder=""
						v-model="form.name"
						data-vv-name="name"
						:error-messages="errors.name"
						required
					></v-text-field>
				</v-col>
				<v-col cols="6" sm="6">
					<v-text-field
						label="编码"
						placeholder=""
						v-model="form.code"
						:error-messages="errors.code"
					></v-text-field>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="4">
					<v-select
						:items="options['ChartType']"
						v-model="form.type"
						label="类型"
						auto
						required
						item-text="title"
						item-value="value"
					></v-select>
				</v-col>
				<v-col cols="4">
					<v-select
						:items="options['ChartStatus']"
						v-model="form.status"
						label="状态"
						auto
						required
						item-text="title"
						item-value="value"
					></v-select>
				</v-col>
				<v-col cols="4">
					<v-text-field
						label="结果集数量*"
						type="number"
						placeholder=""
						v-model.number="form.size"
						:error-messages="errors.name"
						required
					></v-text-field>
				</v-col>
			</v-row>
			<v-col cols="12" class="align-center" v-if="columns">
				<v-subheader>显示列（报表需要配置列名)</v-subheader>
				<v-checkbox
					v-for="(l, k) in columns"
					:key="l.id"
					class="d-inline-block"
					v-model="form.colnames"
					:label="l.displayname"
					:value="l.name"
				></v-checkbox>
				<v-subheader>注意：数值小数点保留2位，太多会无法显示</v-subheader>
			</v-col>
			<v-col cols="12" class="align-center" v-if="parameters">
				<v-subheader>参数取值(注意：不能包含双引号，因为会保存为json)</v-subheader>
				<v-table>
					<template v-slot:default>
						<thead>
							<tr>
								<th class="text-left" v-for="(param, i) in parameters" :key="i">
									{{ param['label'] }} ({{ param.name }})
								</th>
								<th>操作</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(paramSet, i) in paramSets" :key="i">
								<td v-for="(param, j) in parameters" :key="j">
									{{ paramSet[param['name']] }}
								</td>
								<td>
									<v-icon @click="editParamSet(i)">$edit</v-icon>
									<v-icon @click="removeParamSet(i)" color="error">$delete</v-icon>
								</td>
							</tr>
						</tbody>
					</template>
				</v-table>
				<template v-for="(param, i) in parameters">
					<v-text-field
						v-if="form.params[param['name']]"
						:key="i"
						v-model="form.params[param['name']]"
						:label="`${param.label}(${param.name})`"
						:value="form.params[param['name']] ? form.params[param['name']].value : ''"
					></v-text-field>
					<v-text-field
						v-else
						v-model="form.params[param['name']]"
						:label="`${param.label}(${param.name})`"
					></v-text-field>
				</template>
				<v-btn @click="addToSet">添加对比参数</v-btn>
				注意添加对比参数目前仅支持类型：折线、柱状图
			</v-col>
			<v-col cols="12">
				<v-textarea v-model="form.description" outlined label="备注" rows="2" hide-details />
			</v-col>
			<div class="d-flex justify-center">
				<slot name="actions" v-bind:object="form"></slot>
			</div>
		</v-card-text>
	</div>
</template>

<script>
import { clone } from 'lodash-es'

export default {
	name: 'ReportChartForm',
	components: {},
	model: {
		prop: 'object',
		event: 'change'
	},
	props: {
		object: { type: Object, default: null },
		errors: {
			type: Object,
			default: () => {
				return {}
			}
		}
	},
	data: () => ({
		form: {},
		report: null,
		parameters: [],
		columns: [],
		options: {},
		paramSets: [] //多组参数 - 支持多组参数
	}),
	computed: {},
	watch: {},
	mounted() {
		this.form = clone(this.object)

		this.$http.get(`/report/meta/ChartStatus,ChartType`).then((r) => {
			this.options = r
		})
		if (this.form && this.form.report_id) {
			this.getReport()
			this.getParameters(this.form.report_id)
			this.getColumns(this.form.report_id)
		}
	},
	methods: {
		clear() {
			this.form = {}
		},
		addToSet() {
			let exists = this.paramSets.find((e) => {
				console.debug('e', e, JSON.stringify(e), JSON.stringify(this.form.params))
				return JSON.stringify(e) == JSON.stringify(this.form.params)
			})
			console.debug('exists', exists, this.paramSets.length)
			if (exists) return
			this.paramSets.push(clone(this.form.params))
			this.$set(this, 'paramSets', this.paramSets)
			// this.form.params = {}
			this.$set(this.form, 'paramSets', this.paramSets)
		},
		editParams() {
			console.log('edit')
		},
		deleteParams() {
			console.log('delete')
		},
		getReport() {
			this.$api.report.getById(this.object.report_id, (r) => {
				this.report = r
			})
		},
		getParameters(id) {
			this.$api.report.getParameters(id, (r) => {
				this.parameters = r
				this.paramSets = this.form.paramSets ? this.form.paramSets : []
				let tmp = clone(this.f)
				if (!this.form.params) this.form.params = {}
				//脏数据 - 空数组
				if (this.form.params.length == 0) this.form.params = {}
				this.parameters.forEach((e) => {
					let pname = e['name']
					if (!this.form.params[pname]) {
						tmp[pname] = e.defaultValue ? e.defaultValue : ''
					} else tmp[pname] = this.form.params[pname]
				})
				this.$set(this.form, 'params', tmp)
			})
		},
		getColumns(id) {
			this.$api.report.getColumns(id, (r) => {
				this.columns = r //[id]
			})
		},
		editParamSet(i) {
			this.form.params = this.paramSets[i]
		},
		removeParamSet(i) {
			this.paramSets.splice(i, 1)
		}
	}
}
</script>
<style>
.CodeMirror {
	height: 100%;
}
</style>
